import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
import state from "./state"

Vue.use(Vuex);
// const STORAGE_KEY = "language-storage";

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
